import {RootState} from "../../../../app/store";


export const getRegisterState = (state: RootState) => state.registerForm;